<div class="static-top-cont">
    <p class="static-pray-read">{{biblequotes}}</p>
    <p class="static-bible-num mar-t-zero">{{verses}}</p>
</div>